<template>
  <component :is="el" :label="label" :required="required">
    <span v-if="noForm && showLabel">{{label}}</span>
    <el-select v-if="!disabled"
      v-model="formData"
      :disabled="disabled"
      :placeholder="placeholder"
      value-key="value"
      @change="updated">

      <el-option
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>

    </el-select>
    <span v-else><b>{{value}}</b></span>

  </component>
</template>

<script>

export default {
  name: 'select-policy-type',

  props: {
    label: {
      type: String,
      default: 'Policy Type'
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      items: this.getConfig().selects.policyType,
      el: this.noForm ? 'div' : 'el-form-item'

    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectInsurancePolicyType.vue?29558e70